import { amber, deepOrange, green, grey, lightGreen, orange } from '@mui/material/colors';
import icon0PercentAvailable from '../assets/images/bike-stations/bss-0-bikes-marker.svg';
import icon1PercentAvailable from '../assets/images/bike-stations/bss-1-bikes-marker.svg';
import icon10PercentAvailable from '../assets/images/bike-stations/bss-10-bikes-marker.svg';
import icon100PercentAvailable from '../assets/images/bike-stations/bss-100-bikes-marker.svg';
import icon11PercentAvailable from '../assets/images/bike-stations/bss-11-bikes-marker.svg';
import icon12PercentAvailable from '../assets/images/bike-stations/bss-12-bikes-marker.svg';
import icon13PercentAvailable from '../assets/images/bike-stations/bss-13-bikes-marker.svg';
import icon14PercentAvailable from '../assets/images/bike-stations/bss-14-bikes-marker.svg';
import icon15PercentAvailable from '../assets/images/bike-stations/bss-15-bikes-marker.svg';
import icon16PercentAvailable from '../assets/images/bike-stations/bss-16-bikes-marker.svg';
import icon17PercentAvailable from '../assets/images/bike-stations/bss-17-bikes-marker.svg';
import icon18PercentAvailable from '../assets/images/bike-stations/bss-18-bikes-marker.svg';
import icon19PercentAvailable from '../assets/images/bike-stations/bss-19-bikes-marker.svg';
import icon2PercentAvailable from '../assets/images/bike-stations/bss-2-bikes-marker.svg';
import icon20PercentAvailable from '../assets/images/bike-stations/bss-20-bikes-marker.svg';
import icon21PercentAvailable from '../assets/images/bike-stations/bss-21-bikes-marker.svg';
import icon22PercentAvailable from '../assets/images/bike-stations/bss-22-bikes-marker.svg';
import icon23PercentAvailable from '../assets/images/bike-stations/bss-23-bikes-marker.svg';
import icon24PercentAvailable from '../assets/images/bike-stations/bss-24-bikes-marker.svg';
import icon25PercentAvailable from '../assets/images/bike-stations/bss-25-bikes-marker.svg';
import icon26PercentAvailable from '../assets/images/bike-stations/bss-26-bikes-marker.svg';
import icon27PercentAvailable from '../assets/images/bike-stations/bss-27-bikes-marker.svg';
import icon28PercentAvailable from '../assets/images/bike-stations/bss-28-bikes-marker.svg';
import icon29PercentAvailable from '../assets/images/bike-stations/bss-29-bikes-marker.svg';
import icon3PercentAvailable from '../assets/images/bike-stations/bss-3-bikes-marker.svg';
import icon30PercentAvailable from '../assets/images/bike-stations/bss-30-bikes-marker.svg';
import icon31PercentAvailable from '../assets/images/bike-stations/bss-31-bikes-marker.svg';
import icon32PercentAvailable from '../assets/images/bike-stations/bss-32-bikes-marker.svg';
import icon33PercentAvailable from '../assets/images/bike-stations/bss-33-bikes-marker.svg';
import icon34PercentAvailable from '../assets/images/bike-stations/bss-34-bikes-marker.svg';
import icon35PercentAvailable from '../assets/images/bike-stations/bss-35-bikes-marker.svg';
import icon36PercentAvailable from '../assets/images/bike-stations/bss-36-bikes-marker.svg';
import icon37PercentAvailable from '../assets/images/bike-stations/bss-37-bikes-marker.svg';
import icon38PercentAvailable from '../assets/images/bike-stations/bss-38-bikes-marker.svg';
import icon39PercentAvailable from '../assets/images/bike-stations/bss-39-bikes-marker.svg';
import icon4PercentAvailable from '../assets/images/bike-stations/bss-4-bikes-marker.svg';
import icon40PercentAvailable from '../assets/images/bike-stations/bss-40-bikes-marker.svg';
import icon41PercentAvailable from '../assets/images/bike-stations/bss-41-bikes-marker.svg';
import icon42PercentAvailable from '../assets/images/bike-stations/bss-42-bikes-marker.svg';
import icon43PercentAvailable from '../assets/images/bike-stations/bss-43-bikes-marker.svg';
import icon44PercentAvailable from '../assets/images/bike-stations/bss-44-bikes-marker.svg';
import icon45PercentAvailable from '../assets/images/bike-stations/bss-45-bikes-marker.svg';
import icon46PercentAvailable from '../assets/images/bike-stations/bss-46-bikes-marker.svg';
import icon47PercentAvailable from '../assets/images/bike-stations/bss-47-bikes-marker.svg';
import icon48PercentAvailable from '../assets/images/bike-stations/bss-48-bikes-marker.svg';
import icon49PercentAvailable from '../assets/images/bike-stations/bss-49-bikes-marker.svg';
import icon5PercentAvailable from '../assets/images/bike-stations/bss-5-bikes-marker.svg';
import icon50PercentAvailable from '../assets/images/bike-stations/bss-50-bikes-marker.svg';
import icon51PercentAvailable from '../assets/images/bike-stations/bss-51-bikes-marker.svg';
import icon52PercentAvailable from '../assets/images/bike-stations/bss-52-bikes-marker.svg';
import icon53PercentAvailable from '../assets/images/bike-stations/bss-53-bikes-marker.svg';
import icon54PercentAvailable from '../assets/images/bike-stations/bss-54-bikes-marker.svg';
import icon55PercentAvailable from '../assets/images/bike-stations/bss-55-bikes-marker.svg';
import icon56PercentAvailable from '../assets/images/bike-stations/bss-56-bikes-marker.svg';
import icon57PercentAvailable from '../assets/images/bike-stations/bss-57-bikes-marker.svg';
import icon58PercentAvailable from '../assets/images/bike-stations/bss-58-bikes-marker.svg';
import icon59PercentAvailable from '../assets/images/bike-stations/bss-59-bikes-marker.svg';
import icon6PercentAvailable from '../assets/images/bike-stations/bss-6-bikes-marker.svg';
import icon60PercentAvailable from '../assets/images/bike-stations/bss-60-bikes-marker.svg';
import icon61PercentAvailable from '../assets/images/bike-stations/bss-61-bikes-marker.svg';
import icon62PercentAvailable from '../assets/images/bike-stations/bss-62-bikes-marker.svg';
import icon63PercentAvailable from '../assets/images/bike-stations/bss-63-bikes-marker.svg';
import icon64PercentAvailable from '../assets/images/bike-stations/bss-64-bikes-marker.svg';
import icon65PercentAvailable from '../assets/images/bike-stations/bss-65-bikes-marker.svg';
import icon66PercentAvailable from '../assets/images/bike-stations/bss-66-bikes-marker.svg';
import icon67PercentAvailable from '../assets/images/bike-stations/bss-67-bikes-marker.svg';
import icon68PercentAvailable from '../assets/images/bike-stations/bss-68-bikes-marker.svg';
import icon69PercentAvailable from '../assets/images/bike-stations/bss-69-bikes-marker.svg';
import icon7PercentAvailable from '../assets/images/bike-stations/bss-7-bikes-marker.svg';
import icon70PercentAvailable from '../assets/images/bike-stations/bss-70-bikes-marker.svg';
import icon71PercentAvailable from '../assets/images/bike-stations/bss-71-bikes-marker.svg';
import icon72PercentAvailable from '../assets/images/bike-stations/bss-72-bikes-marker.svg';
import icon73PercentAvailable from '../assets/images/bike-stations/bss-73-bikes-marker.svg';
import icon74PercentAvailable from '../assets/images/bike-stations/bss-74-bikes-marker.svg';
import icon75PercentAvailable from '../assets/images/bike-stations/bss-75-bikes-marker.svg';
import icon76PercentAvailable from '../assets/images/bike-stations/bss-76-bikes-marker.svg';
import icon77PercentAvailable from '../assets/images/bike-stations/bss-77-bikes-marker.svg';
import icon78PercentAvailable from '../assets/images/bike-stations/bss-78-bikes-marker.svg';
import icon79PercentAvailable from '../assets/images/bike-stations/bss-79-bikes-marker.svg';
import icon8PercentAvailable from '../assets/images/bike-stations/bss-8-bikes-marker.svg';
import icon80PercentAvailable from '../assets/images/bike-stations/bss-80-bikes-marker.svg';
import icon81PercentAvailable from '../assets/images/bike-stations/bss-81-bikes-marker.svg';
import icon82PercentAvailable from '../assets/images/bike-stations/bss-82-bikes-marker.svg';
import icon83PercentAvailable from '../assets/images/bike-stations/bss-83-bikes-marker.svg';
import icon84PercentAvailable from '../assets/images/bike-stations/bss-84-bikes-marker.svg';
import icon85PercentAvailable from '../assets/images/bike-stations/bss-85-bikes-marker.svg';
import icon86PercentAvailable from '../assets/images/bike-stations/bss-86-bikes-marker.svg';
import icon87PercentAvailable from '../assets/images/bike-stations/bss-87-bikes-marker.svg';
import icon88PercentAvailable from '../assets/images/bike-stations/bss-88-bikes-marker.svg';
import icon89PercentAvailable from '../assets/images/bike-stations/bss-89-bikes-marker.svg';
import icon9PercentAvailable from '../assets/images/bike-stations/bss-9-bikes-marker.svg';
import icon90PercentAvailable from '../assets/images/bike-stations/bss-90-bikes-marker.svg';
import icon91PercentAvailable from '../assets/images/bike-stations/bss-91-bikes-marker.svg';
import icon92PercentAvailable from '../assets/images/bike-stations/bss-92-bikes-marker.svg';
import icon93PercentAvailable from '../assets/images/bike-stations/bss-93-bikes-marker.svg';
import icon94PercentAvailable from '../assets/images/bike-stations/bss-94-bikes-marker.svg';
import icon95PercentAvailable from '../assets/images/bike-stations/bss-95-bikes-marker.svg';
import icon96PercentAvailable from '../assets/images/bike-stations/bss-96-bikes-marker.svg';
import icon97PercentAvailable from '../assets/images/bike-stations/bss-97-bikes-marker.svg';
import icon98PercentAvailable from '../assets/images/bike-stations/bss-98-bikes-marker.svg';
import icon99PercentAvailable from '../assets/images/bike-stations/bss-99-bikes-marker.svg';
import iconClosedStation from '../assets/images/bike-stations/bss-closed-station-marker.svg';
export class BikeStation {
  constructor(id, code, label, location, capacity, availableClassicBikes, availableEBikes, availableLots, providerId, updated, status, history) {
    this.id = id;
    this.code = code;
    this.label = label;
    this.location = location;
    this.capacity = capacity;
    this.availableClassicBikes = availableClassicBikes;
    this.availableEBikes = availableEBikes;
    this.availableLots = availableLots;
    this.providerId = providerId;
    this.updated = updated;
    this.status = status;
    this.history = history;
    this.availableBikesPercentage = this.capacity ? Math.round((this.availableClassicBikes + this.availableEBikes) * 100 / this.capacity) : 0;
  }
  get name() {
    return `${this.label.trim()}${this.code ? ` - ${this.code}` : ''}`;
  }
  get color() {
    if (this.status === 'closed') return grey[500];
    if (this.availableBikesPercentage >= 80) return green[500];
    if (this.availableBikesPercentage >= 60) return lightGreen[500];
    if (this.availableBikesPercentage >= 40) return amber[500];
    if (this.availableBikesPercentage >= 20) return orange[500];
    return deepOrange[500];
  }
}
export const bikeStationIcons = {
  0: icon0PercentAvailable,
  1: icon1PercentAvailable,
  2: icon2PercentAvailable,
  3: icon3PercentAvailable,
  4: icon4PercentAvailable,
  5: icon5PercentAvailable,
  6: icon6PercentAvailable,
  7: icon7PercentAvailable,
  8: icon8PercentAvailable,
  9: icon9PercentAvailable,
  10: icon10PercentAvailable,
  11: icon11PercentAvailable,
  12: icon12PercentAvailable,
  13: icon13PercentAvailable,
  14: icon14PercentAvailable,
  15: icon15PercentAvailable,
  16: icon16PercentAvailable,
  17: icon17PercentAvailable,
  18: icon18PercentAvailable,
  19: icon19PercentAvailable,
  20: icon20PercentAvailable,
  21: icon21PercentAvailable,
  22: icon22PercentAvailable,
  23: icon23PercentAvailable,
  24: icon24PercentAvailable,
  25: icon25PercentAvailable,
  26: icon26PercentAvailable,
  27: icon27PercentAvailable,
  28: icon28PercentAvailable,
  29: icon29PercentAvailable,
  30: icon30PercentAvailable,
  31: icon31PercentAvailable,
  32: icon32PercentAvailable,
  33: icon33PercentAvailable,
  34: icon34PercentAvailable,
  35: icon35PercentAvailable,
  36: icon36PercentAvailable,
  37: icon37PercentAvailable,
  38: icon38PercentAvailable,
  39: icon39PercentAvailable,
  40: icon40PercentAvailable,
  41: icon41PercentAvailable,
  42: icon42PercentAvailable,
  43: icon43PercentAvailable,
  44: icon44PercentAvailable,
  45: icon45PercentAvailable,
  46: icon46PercentAvailable,
  47: icon47PercentAvailable,
  48: icon48PercentAvailable,
  49: icon49PercentAvailable,
  50: icon50PercentAvailable,
  51: icon51PercentAvailable,
  52: icon52PercentAvailable,
  53: icon53PercentAvailable,
  54: icon54PercentAvailable,
  55: icon55PercentAvailable,
  56: icon56PercentAvailable,
  57: icon57PercentAvailable,
  58: icon58PercentAvailable,
  59: icon59PercentAvailable,
  60: icon60PercentAvailable,
  61: icon61PercentAvailable,
  62: icon62PercentAvailable,
  63: icon63PercentAvailable,
  64: icon64PercentAvailable,
  65: icon65PercentAvailable,
  66: icon66PercentAvailable,
  67: icon67PercentAvailable,
  68: icon68PercentAvailable,
  69: icon69PercentAvailable,
  70: icon70PercentAvailable,
  71: icon71PercentAvailable,
  72: icon72PercentAvailable,
  73: icon73PercentAvailable,
  74: icon74PercentAvailable,
  75: icon75PercentAvailable,
  76: icon76PercentAvailable,
  77: icon77PercentAvailable,
  78: icon78PercentAvailable,
  79: icon79PercentAvailable,
  80: icon80PercentAvailable,
  81: icon81PercentAvailable,
  82: icon82PercentAvailable,
  83: icon83PercentAvailable,
  84: icon84PercentAvailable,
  85: icon85PercentAvailable,
  86: icon86PercentAvailable,
  87: icon87PercentAvailable,
  88: icon88PercentAvailable,
  89: icon89PercentAvailable,
  90: icon90PercentAvailable,
  91: icon91PercentAvailable,
  92: icon92PercentAvailable,
  93: icon93PercentAvailable,
  94: icon94PercentAvailable,
  95: icon95PercentAvailable,
  96: icon96PercentAvailable,
  97: icon97PercentAvailable,
  98: icon98PercentAvailable,
  99: icon99PercentAvailable,
  100: icon100PercentAvailable,
  closed: iconClosedStation
};